import { AxiosResponse } from "axios";
import { API } from "../index";
import { getDeviceId, getDeviceName } from "../auth";

const devicePayload = () => ({
  device_id: getDeviceId(),
  device_name: getDeviceName(),
  client_source: "crm",
});
import { REDIRECT_URI } from "../../common/social/kakao/api";

export const authService = {
  postPhoneAuth: async (phoneNum: string): Promise<AxiosResponse> => {
    return await API.post(`/auth/`, { phone_num: phoneNum });
  },

  postPhoneLogin: async (phoneNum: string): Promise<AxiosResponse> => {
    return await API.post(`/api/token/`, { phone_num: phoneNum, ...devicePayload() });
  },

  postKakaoToken: async (kakaoToken: string): Promise<AxiosResponse> => {
    return await API.post(`/api/token/`, { kakao_token: kakaoToken, ...devicePayload() });
  },

  // 결정 87(2026-10-15): 인가 코드 교환을 백엔드에서 한다(REST 키·Client Secret을 브라우저가 쓰지 않음).
  // restApiKey 인자는 호출부 호환용으로 남겨 두고 쓰지 않는다.
  exchangeKakaoCode: async (code: string, _restApiKey?: string): Promise<AxiosResponse> => {
    return await API.post(`/api/v2/auth/kakao-exchange`, { code, redirect_uri: REDIRECT_URI });
  },

  unlinkKakaoAccount: async (): Promise<AxiosResponse> => {
    return await API.post(`https://kapi.kakao.com/v1/user/unlink`, {}, {
      headers: { 
        baseURL: ''
      }
    });
  },

  adminLogin: async (phone_num: string, password: string): Promise<AxiosResponse> => {
    return await API.post("/api/token/admin/", { phone_num, password, ...devicePayload() });
  },

  // 결정 313: crm.amzinfra.site SSO 토큰 → 기존 관리자 토큰
  ssoLogin: async (token: string): Promise<AxiosResponse> => {
    return await API.post("/api/token/sso/", { token, ...devicePayload() });
  },

  getAdminLoginConfig: async (): Promise<AxiosResponse> => {
    return await API.get("/api/token/admin/config/");
  },

  refreshToken: () => {
    return API.post('/api/token/refresh/', {
      refresh_token: localStorage.getItem('refresh_token'),
      ...devicePayload(),
    });
  },

  getSiteAuthSessions: async (siteId: number | string): Promise<AxiosResponse> => {
    return await API.get(`/api/v2/sites/${siteId}/auth-sessions`);
  },

  revokeSiteAuthSession: async (siteId: number | string, sessionId: string): Promise<AxiosResponse> => {
    return await API.post(`/api/v2/sites/${siteId}/auth-sessions/${sessionId}/revoke`, {});
  }
};

export const changeCancelableUserConfirm = async (isConfirm: boolean) => {
  return API.put('/sites/cancelable-user-confirm/', {
    confirm: isConfirm,
    read: true
  });
};

export const changeCancelableUserRead = async () => {
  return API.put('/sites/cancelable-user-confirm/', {
    confirm: false,
    read: true
  });
};
